import BaseObjectDirective from './BaseObjectDirective';

/**
 * AsfResponseShortTextBoxObjectCtrl is a controller class for handling the behavior of a short textbox object in the ASF response system.
 * It extends the BaseObjectDirective class and provides specific functionalities for textbox preferences, validation, and initialization.
 */
export class AsfResponseShortTextBoxObjectCtrl extends BaseObjectDirective {
    /**
     * Constructor for AsfResponseShortTextBoxObjectCtrl.
     * @param {Object} $injector - AngularJS injector service.
     * @param {Object} $scope - AngularJS scope service.
     * @param {Object} $rootScope - AngularJS root scope service.
     * @param {Object} $signals - Signal service for event handling.
     * @param {Object} $interval - AngularJS interval service.
     * @param {Object} $bridges - Bridge service for cross-component communication.
     * @param {Object} $timeout - AngularJS timeout service.
     * @param {Object} TaskInfoService - Service for retrieving task information.
     * @param {Object} $translate - AngularJS translation service.
     */
    constructor($injector, $scope, $rootScope, $signals, $interval, $bridges, $timeout, TaskInfoService, $translate) {
        super($injector, $scope);

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$bridges = $bridges;
        this.TaskInfoService = TaskInfoService;
        this.$translate = $translate;

        $scope.isCMS = $rootScope.isCMS;
        $scope.isPreview = $rootScope.isPreview;
        $scope.editMode = false;
        $scope.prefsMode = false;

        const taskInfo = TaskInfoService.getTaskInfo();
        $scope.writingDirection = $rootScope.isJournal ? "ltr" : taskInfo.getInputLanguage().writingDirection;
        $scope.langISO = $rootScope.isJournal ? $translate.preferredLanguage() : taskInfo.getISOInputLanguageCode();

        const _tmp = $scope.resetChanges;
        $scope.resetChanges = () => {
            _tmp();
            this.$scope.initPreferences();
        };

        /**
         * Validates the paste event to prevent certain types of content from being pasted.
         * @param {Event} event - The paste event.
         */
        $scope.isValidPaste = function(event) {
            const desmosTex = angular.element(document).injector().get('$rootScope').copyTexString;
            const pasteData = event.originalEvent.clipboardData.getData('Text');
            if (pasteData.match(/(<|&lt;)math.*MathML.*(>|&gt;).*(<|&lt;)\/math(>|&gt;)/) || pasteData == desmosTex || desmosTex.includes(pasteData)) {
                event.preventDefault();
            }
        };

        /**
         * Initializes the preferences for the textbox object.
         */
        $scope.initPreferences = () => {
            const predefinedSize = parseInt($scope.$parent.$parent.size) === 100 ? '919' : '414';

            const width = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().width : null);
            const placeholder = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().placeholder : null);
            const label = (typeof $scope.contentObject.getPreferences() != "undefined" ? $scope.contentObject.getPreferences().label : null);
            const includedInPDF = (typeof $scope.contentObject.getPreferences() !== "undefined" ? $scope.contentObject.getPreferences().includedInPDF : true);

            $scope.$watch('preferencesValues', function(val1, val2) {
                if (val1 == val2)
                    return;
                const preferences = {};
                angular.forEach($scope.preferencesValues, function(value, key) {
                    preferences[key] = value;
                });
                $scope.contentObject.setPreferences(preferences);
            }, true);

            $scope.preferencesValues = {};
            $scope.preferencesValues['width'] = width ? width : predefinedSize;
            $scope.preferencesValues['placeholder'] = placeholder;
            $scope.preferencesValues['label'] = label;
            $scope.preferencesValues['includedInPDF'] = typeof includedInPDF !== 'undefined' ? includedInPDF : true;

            $scope.preferences = [
                {
                    '03-dimensions': [
                        {'type': 'input', 'name': 'Width (px)', 'valueKey': 'width', 'cssClass': 'smallInput','maxlength':3},
                    ],
                    '02-placeholder': [
                        {'type': 'input', 'name': 'Placeholder text', 'valueKey': 'placeholder'},
                    ],
                    '01-label': [
                        {'type': 'input', 'name': 'Label', 'valueKey': 'label','maxlength':40},
                    ],
                    '04-includedInPDF': [
                        {'type': 'checkbox', 'name': 'Included in Response PDF', 'valueKey': 'includedInPDF'}
                    ]
                },
            ];
        };

        $scope.initPreferences();

        /**
         * Handles the focus event on the textbox.
         */
        $scope.onFocus = () => {
            $bridges.runtime().setLastKeyboardLanguage();
        };
    }
}

/**
 * Registers the AsfResponseShortTextboxObject directive with the provided module.
 * @param {Object} module - The AngularJS module to register the directive with.
 */
export default function registerAsfResponseShortTextboxObjectDirective(module) {
    module.directive('asfResponseShortTextboxObject', function($compile, $bridges, $config, TaskDataService, $rootScope, $interval, $http, $signals, TaskInfoService) {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                "contentObject": "=",
                "questionPart": "="
            },
            templateUrl: "/views/ib/contentobjects/response-short-textbox.html",
            controller: AsfResponseShortTextBoxObjectCtrl
        };
    });

    module.run(['ContentObjectRegistryService', function(ContentObjectRegistryService) {
        const obj = [{
            "uuid": "",
            "content": "",
            "objectType": "response-short-textbox",
            "type": "contentObject",
            "entity_content": "",
            "preferences": {
                "width": "",
                "placeholder": "",
                "label": "",
                "includedInPDF" : true
            }
        }];
        const objProperties = {
            type: "response-short-textbox",
            isResponse: true,
            label: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.RESPONSE-SHORT-TEXTBOX.LABEL',
            cssClass: "new-short-textbox-object",
            icon: "cms/icon-response-textbox-short.png",
            description: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.RESPONSE-SHORT-TEXTBOX.DESCRIPTION',
            group: {
                id: 1
            }
        };
        ContentObjectRegistryService.register(obj, objProperties);
    }]);
}